import type { ReactNode } from "react";

interface DetailRowProps {
	label: string;
	value: ReactNode;
}

const DetailRow = ({ label, value }: DetailRowProps) => (
	<div className="flex flex-col gap-1 text-sm sm:flex-row sm:items-start sm:justify-between sm:gap-4">
		<span className="text-muted-foreground shrink-0">{label}:</span>
		<div className="flex items-center gap-2 font-medium sm:text-right min-w-0">
			{value}
		</div>
	</div>
);

export default DetailRow;
